/**
 * Single source of truth for analyze-tab ordering on the home page.
 * Edit the array to reorder tabs in the UI; nothing else needs to change.
 *
 * `file` covers both image and PDF. They are one concept from the user's point
 * of view and one code path server-side: same presign, same key derivation,
 * same size cap. The API still distinguishes `image` and `pdf` as input types,
 * but that is derived from the picked file's MIME type rather than from a tab
 * the user has to choose first.
 */
export const INPUT_TABS_ORDER = ['file', 'url', 'text'] as const;
export type InputTabId = (typeof INPUT_TABS_ORDER)[number];

export const INPUT_TAB_LABEL: Record<InputTabId, string> = {
  file: 'File',
  url: 'URL',
  text: 'Text',
};
